/**
 * useTourStore.ts
 * Zustand store for tour state management
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface TourState {
  hasSeenTour: boolean;
  isRunning: boolean;
  setHasSeenTour: (seen: boolean) => void;
  setIsRunning: (running: boolean) => void;
  startTour: () => void;
  endTour: () => void;
  resetTour: () => void;
}

export const useTourStore = create<TourState>()(
  persist(
    set => ({
      hasSeenTour: false,
      isRunning: false,

      setHasSeenTour: seen => set({ hasSeenTour: seen }),
      setIsRunning: running => set({ isRunning: running }),

      startTour: () => set({ isRunning: true }),
      endTour: () => set({ isRunning: false, hasSeenTour: true }),
      resetTour: () => set({ hasSeenTour: false, isRunning: false }),
    }),
    {
      name: 'exam-tour-storage',
      partialize: state => ({ hasSeenTour: state.hasSeenTour }),
    }
  )
);
